export const ROUTES = {
  LOGIN: "login",
  DASHBOARD: "dashboard",
  RECOVERY_PASSWORD: "recovery-password",
  POSTS: "posts",
  PODCASTS: "podcasts",
  SYSTEM_USERS: "system-users",
  ADD_ORGANIZER: "add-organizer",
  ORGANIZERS: "organizers-list",
  EXPERTS: "experts-list",
  EVENTS: "events-list",
  EDIT_EVENT: "edit-event",
  ADD_EVENT: "add-event",
  ADD_ADMIN_POST: "add-admin-post",
  EDIT_ADMIN_POST: "edit-admin-post",
  FEATURED_PODCAST: "featured-podcasts",
  EDIT_FEATURED_PODCAST: "edit-featured-podcast",
  ADD_FEATURED_PODCAST: "add-featured-podcast",
  ADMIN_POSTS: "admin-posts",
  MODEL_GENERATOR: "model-generator",
  USERS_REPORTS: "users-reports",
  VIEW_USER_REPORT: "view-user-report",
  FEEDBACKS: "feedbacks",
  EDIT_FEEDBACK: "edit-feedback",
  ROLES: "roles-management",
  PERMISSIONS: "view-permissions",
  USERS: "users-list",
  TASKS: "tasks-list",
  BADGES: "badges-list",
  EDIT_BADGE: "edit-badge",
  ADD_BADGE: "add-badge",
  // Podcast Categories
  ADD_PODCAST_CATEGORY: "add-podcast-category",
  EDIT_PODCAST_CATEGORY: "edit-podcast-category",
  PODCAST_CATEGORIES: "podcast-categories",
  // Programs
  ADD_PROGRAM: "add-program",
  EDIT_PROGRAM: "edit-program",
  PROGRAMS: "programs-list",
  // Clubs
  ADD_CLUB: "add-club",
  EDIT_CLUB: "edit-club",
  CLUBS: "clubs",

  // Clubs Code
  ADD_CLUB_CODE: 'add-club-code',
  LIST_CLUB_CODE: 'list-club-code'

};
